module.exports = __webpack_public_path__ + "img/backpack.e149c09f.jpg";